module.exports = __webpack_public_path__ + "img/zscqzyzh.1b620819.png";